// Motivo del fallo de pago de la suscripción (lo clasifica la API; el código exacto de Stripe no llega al cliente)
const RETRYABLE_REASONS = ['authentication_required', 'insufficient_funds', 'temporary'];

export const getPaymentFailureText = (reason?: string | null): string => {
    switch (reason) {
        case 'authentication_required':
            return 'Tu banco necesita que confirmes el pago de tu suscripción.';
        case 'expired_card':
            return 'Tu tarjeta ha caducado. Actualiza tu método de pago.';
        case 'insufficient_funds':
            return 'La tarjeta no tiene saldo suficiente. Puedes volver a intentarlo o usar otra tarjeta.';
        case 'temporary':
            return 'Ha habido un problema temporal con el pago. Puedes volver a intentarlo o usar otra tarjeta.';
        default:
            return 'No hemos podido cobrar tu suscripción. Actualiza tu método de pago.';
    }
};

// Con estos motivos la tarjeta guardada puede servir: confirmar el 3D Secure o volver a intentar el cobro
export const canRetryPayment = (reason?: string | null): boolean => RETRYABLE_REASONS.includes(reason ?? '');

export const getRetryButtonLabel = (reason?: string | null): string =>
    reason === 'authentication_required' ? 'Confirmar pago' : 'Reintentar el pago';
